import { render } from "./ImageSettings.vue?vue&type=template&id=a7d85cec"
import script from "./ImageSettings.vue?vue&type=script&lang=js"
export * from "./ImageSettings.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__